import { useYearQuarterNavigation } from 'hooks';
import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

import { getCapacity } from 'RestAPIs/roster/formation';

import { scenarioAtom } from '../atoms';

import { VIEW } from './const';

type Options = {
  selectedFunctionId?: number;
  selectedCostCenterId?: number;
};

export const useGetCapacityQuery = (options: Options) => {
  const scenario = useRecoilValue(scenarioAtom);
  const { year, quarter, isViewPerWeek } = useYearQuarterNavigation();
  const { selectedFunctionId, selectedCostCenterId } = options;

  return useQuery(
    [
      'formation',
      scenario?.scenarioId,
      year,
      isViewPerWeek,
      selectedFunctionId,
      selectedCostCenterId,
      quarter
    ],
    async () => {
      const { data } = await getCapacity({
        scenarioId: scenario?.scenarioId as number,
        year,
        aggregateOn: isViewPerWeek ? VIEW.WEEK : VIEW.MONTH,
        functionId: selectedFunctionId ?? null,
        costCenterId: selectedCostCenterId ?? null,
        quarter: isViewPerWeek ? quarter : null
      });

      return {
        ...data,
        grossFormation: {
          ...data.grossFormation,
          employeeFormations: data.grossFormation.employeeFormations?.map(
            (formation) => ({
              ...formation,
              uuid: uuidv4()
            })
          )
        },
        absenceFormation: {
          ...data.absenceFormation,
          absenceTypeFormations:
            data.absenceFormation.absenceTypeFormations?.map((formation) => ({
              ...formation,
              uuid: uuidv4()
            }))
        },
        ...(data.additionalFormation && {
          additionalFormation: {
            ...data.additionalFormation,
            additionalFormations:
              data.additionalFormation.additionalFormations?.map(
                (formation) => ({
                  ...formation,
                  uuid: uuidv4()
                })
              )
          }
        })
      };
    },
    {
      enabled: !!scenario?.scenarioId
    }
  );
};
